import {AxiosResponseHeaders} from 'axios'
import {useCallback} from 'react'

import {downloadFile} from '../utils'

export const useFileDownload = () => {
  return useCallback((data: Blob, headers: AxiosResponseHeaders) => {
    const disposition = headers['content-disposition'] ?? ''
    const encodedFileName = disposition.split("filename*=UTF-8''")[1]
    if (!encodedFileName) return
    const fileName = decodeURIComponent(encodedFileName)
    downloadFile(data, fileName)
  }, [])
}
